import styled from "@emotion/styled";

import { zIndexes } from "../../utilities";
import {
  HEADER_HEIGHT,
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_PANEL_WIDTH,
  VIEW_BAR_HEIGHT,
} from "../../utilities/constants";

export const SidebarContainer = styled.div`
  display: inline-flex;
  height: 100%;
`;

export const SidebarIconContainer = styled.div`
  display: inline-flex;
  flex-direction: column;

  height: calc(100dvh - ${HEADER_HEIGHT + VIEW_BAR_HEIGHT}px);
  width: ${SIDEBAR_COLLAPSED_WIDTH}px;
  padding-top: 5px;
  padding-bottom: 40px;

  color: ${({ theme }) => theme.generalTextIcon};
  background-color: ${({ theme }) => theme.surfaceVariant};

  border-right: 1px solid ${({ theme }) => theme.surfaceBack_1};

  font-size: ${({ theme }) => theme.fontSizeLarge};
  line-height: 19px;

  z-index: ${zIndexes.mainSidebar};
`;

export const SidebarPanel = styled.div<{ expanded: boolean; type: "main" | "popOut" }>`
  height: 100%;
  overflow-y: auto;
  display: inline-block;

  width: ${SIDEBAR_PANEL_WIDTH}px;

  margin-left: ${({ expanded }) => (expanded ? 0 : -SIDEBAR_PANEL_WIDTH)}px;

  transition: margin-left 300ms ease-in-out;

  z-index: ${({ type }) => (type === "main" ? zIndexes.mainSidebar - 1 : zIndexes.mainSidebar - 2)};
`;
